<template>
  <div class="flex-container">
    <section class="goods-name-container flex-1">
      {{ goodsNameList }}
    </section>
    <div v-if="isShowGoodList" class="detail-container" @click.stop="processShowGoodsDetail">
      <span>共{{ doseCount }}剂</span>
      <van-icon name="cap-arrow" color="#bfbfbf" />
    </div>
    <div v-else class="detail-container">
      <span>共{{ doseCount }}剂</span>
      <van-icon name="cap-arrow" color="#bfbfbf" />
    </div>

    <van-modal-sheet
      v-model="showModal"
      title="商品明细"
      right-text="关闭"
      right-text-color="#8C8C8C"
      @titleRightClick="showModal = false"
    >
      <div>
        <div class="hint" v-if="!isShowBuyCount">
          该中药处方为保密方，支付后可见每味药材的开具数量，敬请谅解。
        </div>
        <div class="goods-list">
          <div class="goods-item" v-for="(item) in goodsList" :key="item.itemId">
            <div class="line-first">
              <span class="goods">{{ item.itemName }}</span>
            </div>
            <div class="line-second">
              <span class="spec">规格: {{ item.drugSpec || item.specifications }}</span>
              <span class="num" v-if="isShowBuyCount">x{{ item.itemNum }}</span>
            </div>
          </div>
        </div>
        <div class="total">
          <span>
            合计：
          </span>
          <span style="font-weight: bold">
            {{doseCount}}剂
          </span>
        </div>
      </div>
    </van-modal-sheet>
  </div>
</template>
<script>
import goodsItem from '@/components/goodsItem.vue';
export default {
  components: {
    goodsItem
  },
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    itemCount: {
      type: Number,
      default: 0
    },
    isShowGoodList: {
      type: Boolean,
      default: false
    },
    isShowBuyCount: {
      type: Boolean,
      default: false
    },
    doseCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    goodsNum() {
      if (this.itemCount) return this.itemCount;
      return this.goodsList.reduce((acc, cur) => acc + cur.itemNum, 0);
    },
    goodsNameList() {
      return (this.goodsList || []).map(goods => goods.itemName).join(';');
    }
  },
  methods: {
    processShowGoodsDetail() {
      this.showModal = true;
    }
  }
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .flex-1 {
    flex: 1;
  }
  .goods-name-container {
    line-height: 18px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .detail-container {
    color: #8c8c8c;
    font-size: 12px;
    padding-left: 12px;
    height: 50px;
    display: inline-flex;
    align-items: center;
  }
}
.hint {
  padding: 8px 12px;
  background: #FFF7E6;
  font-size: 12px;
  font-weight: 400;
  color: #FF8200;
  line-height: 16px;
}
.goods-list {
  padding: 0 12px;
  .goods-item {
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    .line-first {
      margin: 0 20px 8px 0;
      .goods {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        line-height: 16px; 
      }
    }
    .line-second {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .spec {
        flex: 1 1 auto;
        margin-right: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 14px;
      }
      .num {
        flex: 0 0 auto;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 14px;
      }
    }
  }
}

.total {
  height: 48px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #262626;
}

</style>